import React, {useState} from 'react';
import {ViewCabezeraMensajes} from './ViewCabezeraMensajes';

/* A function that returns a component. */
export const CabezeraMensajes = (props) => {
	/* Destructuring the props object. */
	const {closeMenuContacts} = props;

	let nombreUsuario = 'Usuario de prueba';
	let phone = '666-777-888';
	let addres = 'N/A';

	return (
		<ViewCabezeraMensajes
			nombreUsuario={nombreUsuario}
			phone={phone}
			addres={addres}
			closeMenuContacts={closeMenuContacts}
		/>
	);
};
